
import { Injectable } from '@angular/core';
import * as platform from 'platform';


@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {

  constructor() { }

  
  getDeviceType(): number {
    const parsedPlatform = platform.parse(navigator.userAgent);
    const userAgent = navigator.userAgent;
    // console.log('User Agent:', userAgent);
    // console.log('Parsed Platform:', parsedPlatform);

    const isMobile = /Mobile|Android.*Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk|Kindle|Nexus 7|Nexus 10|SM-T|SCH-I800|GT-P|xoom|Transformer/i.test(userAgent);

    if (parsedPlatform.product && parsedPlatform.product.toLowerCase() === 'ipad') {
      // console.log('Device type detected: Tablet');
      return 3; // Tablet
    } else if (isMobile) {
      // console.log('Device type detected: Mobile');
      return 2; // Mobile
    } else if (isTablet) {
      // console.log('Device type detected: Tablet');
      return 3; // Tablet
    } else {
      // console.log('Device type detected: Desktop');
      return 1; // Desktop
    }
  }
}